export const materialsValidator = (fields) => {
  const errors = {};
  if (!fields.name || fields.name.trim() === "") {
    errors.name = "El nombre no puede estar vacío";
  }
  if (!fields.appointment_types || fields.appointment_types.length === 0) {
    errors.appointment_types = "Debes seleccionar un tipo de cita";
  }
  if (!fields.type || fields.type.trim() === "") {
    errors.type = "Debes seleccionar un tipo de valor";
  }
  if (!fields.material_type) {
    errors.material_type = "Debes seleccionar un tipo de material";
  }
  if (fields.type === "single" || fields.type === "multiple") {
    if (fields.material_options)
      for (let index = 0; index < fields.material_options.length; index++) {
        if (
          fields.material_options[index] === undefined ||
          !fields.material_options[index].material_option ||
          !fields.material_options[index].appointment_type ||
          fields.material_options[index].material_option === ""
        ) {
          errors.material_options =
            "Debes rellenar las opciones de material o descartarlas";
          break;
        }
      }
  }
  return errors;
};



// WEBPACK FOOTER //
// ./src/views/Configurator/utils/materialsValidator.js